import {Injectable} from '@angular/core';
import {GenericService} from '../../core/commons/generic.service';
import {City} from '../domain/city';
import {AuthService} from '../../core/security/auth.service';
import {QueryOptions} from '../../core/commons/query.options';
import {RequestMethod} from '@angular/http';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class CityService extends GenericService<City> {

    private cityUrl = '/cities';

    constructor(authService: AuthService) {
        super(authService)
    }

    protected valueToEntity(value: Object): City {
        return new City(value);
    }

    protected getResourcePath(): string {
        return this.cityUrl;
    }

    getDefaultQueryOptions(): QueryOptions {
        return new QueryOptions();
    }

    public getCitiesByProvinceId(id: number): Observable<City[]> {
        return this.doRequest({
            url: this.baseUrl + this.getResourcePath() + '/province/' + id,
            method: RequestMethod.Get
        })
            .concatMap(res => Observable.from(res.json())
                .concatMap(value => this.mapValueToEntityGetAll(value))
                .toArray()
            )
    }


}



// WEBPACK FOOTER //
// ./src/app/profile/service/city.service.ts